import React from "react";
import { useI18next } from "../../../../plugins/gatsby-plugin-ap-i18next/src/useI18next";

import AuthLayout from "../../../layouts/auth-layout";
import RegisterForm from "../forms/register-form";

const Register: React.FC = () => {
    const { t } = useI18next();
    return (
        <AuthLayout title={t("auth.register.title")}>
            <RegisterForm />
        </AuthLayout>
    );
};

export default Register;
